export default function NameAvailability({ isAvailable, name, platform }) {
  if (isAvailable === null)
    return (
      <>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="tw-w-6 tw-h-6 tw-stroke-gray-500 tw-animate-spin"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
            />
          </svg>
        </div>
      </>
    );
  if (isAvailable)
    return (
      <>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="tw-w-6 tw-h-6 tw-stroke-green-500"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span className="pl-1">
            {platform ? '@' : ''}
            {name} is available
            {platform ? (
              ` on ${platform}!`
            ) : (
              <>
                !{' '}
                <a
                  href={`https://www.tkqlhce.com/click-100956265-15083042?url=${encodeURIComponent(
                    `https://www.namecheap.com/domains/registration/results/?domain=${name}`,
                  )}`}
                  target="_blank"
                  rel="nofollow noreferrer noopener"
                  className="tw-text-green-300 hover:tw-text-green-500 tw-underline hover:tw-underline"
                >
                  See cost
                </a>
              </>
            )}
          </span>
        </div>
      </>
    );
  return (
    <>
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="tw-w-6 tw-h-6 tw-stroke-red-500"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <span className="pl-1">
          {platform ? '@' : ''}
          {name} is not available
          {platform ? (
            ` on ${platform}`
          ) : (
            <>
              .{' '}
              <a
                href={`https://www.tkqlhce.com/click-100956265-15083042?url=${encodeURIComponent(
                  `https://www.namecheap.com/domains/registration/results/?domain=${name}`,
                )}`}
                target="_blank"
                rel="nofollow noreferrer noopener"
                className="tw-text-green-300 hover:tw-text-green-500 tw-underline hover:tw-underline"
              >
                View alternatives
              </a>
            </>
          )}
        </span>
      </div>
    </>
  );
}
